import * as dayjs from 'dayjs';
import { AnyHash } from '@hidat/huijs-common';
import { UserMixInterface } from '@splixer/common';
import { Expose, Transform } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';

export class PlayerUserMix implements UserMixInterface {
  @Expose({ name: 'id' })
  id = -1;
  @Expose({ name: 'status' })
  status = 100;
  @Expose({ name: 'created_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  createdAt: dayjs.Dayjs | undefined = undefined;
  @Expose({ name: 'updated_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  updatedAt: dayjs.Dayjs | undefined = undefined;

  @Expose({ name: 'instance_id' })
  instanceId: number | undefined = undefined;
  @Expose({ name: 'listener_id' })
  listenerId: number | undefined = undefined;
  @Expose({ name: 'station_id' })
  stationId: number | undefined = undefined;
  @Expose({ name: 'content_path_id' })
  contentPathId: number | undefined = undefined;

  @Expose({ name: 'name' })
  name: string | undefined = undefined;
  @Expose({ name: 'mix_config' })
  mixConfig: AnyHash = {};
}
